export default __webpack_public_path__ + "static/finindcase1-3e2fa43d6afc7e403533b81db31b8b94.png";